import type { BinderVariant, CardLanguage } from "@/types/binders";

export function binderEditPricingEligible(
  item: BinderVariant,
  language: CardLanguage,
) {
  const cardLanguage = (item.variant.card as any)?.language ?? "english";
  return (
    language === cardLanguage &&
    (!item.scan_identity || item.scan_identity.status === "exact_match")
  );
}

export function binderScanImagePath(items: BinderVariant[]) {
  return items.find((item) => item.scan_image_path)?.scan_image_path ?? null;
}
